import { render, staticRenderFns } from "./groupOrders.vue?vue&type=template&id=e4da4366&"
import script from "./groupOrders.vue?vue&type=script&lang=js&"
export * from "./groupOrders.vue?vue&type=script&lang=js&"
import style0 from "./groupOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports